module.exports = __webpack_public_path__ + "static/commitment-to-safety-sm-6f131b0a61e332988560d86b278ac374.jpg";